// Components==============
import ProjectCard from 'components/UI/ProjectCard/ProjectCard';
import { useRedux } from 'hooks/useRedux';
import { useThemesWithProject } from 'hooks/useThemesWithProject';
import { useTranslate } from 'hooks/useTranslate';
import React, { useContext } from 'react';
import { ThemeWithProjects } from 'typings';
import { getDate } from 'utilities/getDate';
import { GlobalEvidenceContext } from 'utilities/GlobalContext/GlobalEvidence';
import './RecentWork.module.scss';
// =========================

export default function RecentWork() {
  const translate = useTranslate();
  const userId = useRedux((state) => state.authentication?.user?.id);

  const evidence = useContext(GlobalEvidenceContext);

  const courses = useRedux((state) =>
    state.training?.entities.allIds
      .map((id) => state.training?.entities.byId[id])
      .filter(
        (course) => course?.owner?.id === userId || course?.subscription_id
      )

      ?.sort((a, b) => getDate(b?.updated_at) - getDate(a?.updated_at))
  );

  const themesWithProject = useThemesWithProject();

  const newestEvidence = evidence?.slice(0, 4).map((e) => {
    const value =
      e.type === 'training'
        ? courses?.find((c) => c?.id === e.id)
        : themesWithProject.find((t) => t?.project?.id === e.id);

    return { ...value, updated_at: e.evidence.updated_at };
  });

  const newestCourses = courses?.slice(0, 4);
  const newestProjects = themesWithProject?.slice(0, 2);

  const combinedWork = [
    ...(newestEvidence || []),
    ...(newestCourses || []),
    ...(newestProjects || []),
  ]
    .filter((exists) => exists)
    ?.sort((a, b) => getDate(b?.updated_at) - getDate(a?.updated_at));

  // filter out duplicates
  const trainingIds: number[] = [];
  const projectIds: number[] = [];

  const uniqueWork: (ThemeWithProjects | TrainingEntity)[] = [];

  combinedWork?.forEach((work) => {
    if (work && 'title' in work) {
      if (!trainingIds.includes(work.id)) uniqueWork.push(work);
      trainingIds.push(work.id);
    }

    if (work && 'project' in work) {
      if (!projectIds.includes(work.id)) uniqueWork.push(work);
      projectIds.push(work.id);
    }
  });

  let counter = 0;

  const recentWork = uniqueWork
    .map((work) => {
      if (counter < 4) {
        if (work && 'title' in work) {
          counter += 1;
          return { type: 'training', work } as {
            type: 'training';
            work: TrainingEntity;
          };
        }

        if (work && 'project' in work) {
          if (counter === 3) return;
          counter += 2;
          return { type: 'project', work } as {
            type: 'project';
            work: ThemeWithProjects;
          };
        }
      }
      return undefined;
    })
    .filter((exists) => exists);

  if (recentWork?.[1]?.type === 'project' && recentWork.length === 3) {
    recentWork.splice(3, 0, recentWork?.[1]);
    recentWork.splice(1, 1);
  }

  if (!recentWork.length) return <></>;

  return (
    <div styleName="column">
      <strong>{translate('general.terms.recent-work')}</strong>
      {recentWork.map(
        (work, index) =>
          !!work?.work &&
          (work?.type === 'project' ? (
            <ProjectCard
              key={index}
              style={{ height: 'initial', minHeight: '250px' }}
              theme={work.work}
            />
          ) : (
            <></>
          ))
      )}
    </div>
  );
}
